import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function SupportCreate(){
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const [Message, setMessage] = useState('');
    const [Subject, setSubject] = useState('');
    const [TaskFile, setTaskFile] = useState(null);
    const [Type, setType] = useState("");
    const [data, setdata] = useState([]);
    const [Slipno, setSlipno] = useState("");    
    const [Subloading, setSubLoading] = useState(false);


    const inputHandler = (event, editor) => {
        setMessage(editor.getData());
    };

    useEffect(()=>{
        GetTaskType();
    },[]);

        const GetTaskType=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'TaskType',
                headers:headers1,
                data: {
                    
                }
              })
              .then(function (response) {
    
                if(response.data.status == 200)
                {
                    setdata(response.data.value);
    
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }

        const CreateSupport = async () => {
    
            if (!TaskFile) {
                toast.error("Please select a type");
                return; // stop form submission
            }

            if (!Message || Message === "<p></p>") {
                toast.error("Please type a message");
                return;
            }
            setSubLoading(true);
                const formData = new FormData();
                formData.append("msg", Message);
                formData.append("sub", Subject);
                formData.append("type", Type);
                formData.append("slipno", Slipno);

                // agar image select ki ho to add karo
                if (TaskFile) {
                    formData.append("TaskFile", TaskFile);
                }
                
            axios({
                method: 'post',
                url: Global.baseUrl+'CreateSupport',
                headers:{headers1, "Content-Type": "multipart/form-data",},
                data: formData,
              })
    
            .then(function (response) {
                if(response.data.status == 200){
                    toast.success(response.data.message);
                    setMessage("");
                    setTaskFile("");
                    setSubject("");
                    setType("");
                    setSlipno("");
                    setSubLoading(false);
                }else{
                    toast.error(response.data.message);
                    setSubLoading(false);
                }
             
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                }
                setSubLoading(false);
            // console.log(error);
            });
        };

    return(
            <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
               
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="#">
                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Tickets</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Create Tickets</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3 fs-normal-o">
                    <div className="ticket_list_md mt-3">
                        <div className="py-3">
                            <div id="reply_btn">
                                <div className="card shadow-sm">                                            
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <div><label htmlFor="email" className="form-label">Type: <span className="text-danger">*</span></label></div>
                                            <select className="form-select" value={Type} onChange={(e) => setType(e.target.value)}>
                                                <option value="">-- Please Select --</option>
                                                {data.map((item) => (                                         
                                                    <option value={item.task_type}>{item.task_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        {(Type === "S" || Type === "WD" ) && (
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label">Slip No: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={Slipno} onChange={(e) => setSlipno(e.target.value)} placeholder="Please Enter SlipNo" />
                                            </div>
                                        )}

                                        {Type === "OS" && (
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label">Subject: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={Slipno} onChange={(e) => setSlipno(e.target.value)} placeholder="Please Enter Subject" />
                                            </div>
                                        )}
                                                
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label">Message: <span className="text-danger">*</span></label>                                    
                                            <CKEditor editor={ClassicEditor} data={Message} onChange={inputHandler} />
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="attachment-box mt-3">
                                                <label htmlFor="fileUpload" className="text-decoration-none" style={{ fontSize: "15px", cursor: "pointer" }}>
                                                    <i className="bx bx-paperclip"></i>
                                                    Attachments
                                                </label>

                                                <input type="file" id="fileUpload" className="d-none" accept="image/png,image/jpg,image/jpeg,video/*,.pdf,.doc,.docx" onChange={(e) => setTaskFile(e.target.files[0])} />
                                                    
                                                {TaskFile && (
                                                    <div className="mt-2 position-relative d-inline-block">                                                              
                                                    
                                                        {TaskFile && (
                                                            <div className="p-2 border rounded" style={{ width: "250px" }}>
                                                                <p className="mb-1"><strong>File:</strong> {TaskFile.name}</p>

                                                                {TaskFile.type.startsWith("image/") && (
                                                                    <img
                                                                        src={URL.createObjectURL(TaskFile)}
                                                                        alt={TaskFile.name}
                                                                        style={{ width: "100%" }}
                                                                    />
                                                                )}

                                                                {TaskFile.type.startsWith("video/") && (
                                                                    <video
                                                                        src={URL.createObjectURL(TaskFile)}
                                                                        controls
                                                                        style={{ width: "100%" }}
                                                                    />
                                                                )}

                                                                {TaskFile.type.startsWith("application/") && (
                                                                    <a
                                                                        href={URL.createObjectURL(TaskFile)}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        Preview / Open Document
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}


                                                        {/* Remove file */}
                                                        <span className="position-absolute top-0 end-0 bg-danger text-white rounded-circle px-1"
                                                            style={{ fontSize: "15px", cursor: "pointer" }} onClick={() => setTaskFile(null)}
                                                            >
                                                            ×
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {Subloading==false?
                                            <button className="btn btn-primary px-4" onClick={CreateSupport} >
                                                Create
                                            </button>
                                            :
                                            <button className="btn btn-primary px-4" >
                                                Creating...
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            
            
            
                <Footer/>
            </main>
            </>
                
        );
     
}

export default SupportCreate;